<template>
  <div>
    <div ref="widgetContainer">
      <Row class="widget-container">
        <i-col :lg="24" :md="24" :sm="24" :xs="24">
          <QuestionnairesProcessed></QuestionnairesProcessed>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
  import QuestionnairesProcessed from './_questionnaireProcessed'
  export default {
    name: 'QuestionnaireProcessed',
    components: {
      QuestionnairesProcessed
    },
    data() {
      return {}
    },
    computed: {
    },
    watch: {},
    methods: {
      triggerExportPdf() {
        this.$emit('exportPdf', this.$refs.widgetContainer, 'testPDF.pdf')
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/e_QuestionnaireProcessed/QuestionnaireProcessed.vue